import { useResponsiveClass } from "@/utils/useResponsiveClass";


export const ResponsiveGap = ({className=''})=>{
  const getResponsiveClass = useResponsiveClass();
    return(
      <div className={`${getResponsiveClass({
        mobile: "col-span-full",
        tablet: "col-span-6",
        desktop: "col-span-12",
      })} ${className}`}/>
    )
  }